import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

import Style from './style'

import MainHeader from 'widget/MainHeader'

import useGetMyFranchise from 'entity/franchise/useGetMyFranchise'

import DTStyle from 'shared/style/detailTableStyle'
import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import TableLoading from 'shared/ui/TableLoading'
import {ROLE_FRANCHISE_MANAGER} from 'shared/constant/lookup/role'
import useRoleCookie from 'shared/model/useRoleCookie'
import check from './asset/check.svg'
import checked from './asset/checked.svg'
import usePutStoreManagerApprove from 'entity/store/usePutStoreManagerApprove'
import useDeleteStoreManagerApprove from 'entity/store/useDeleteStoreManagerApprove'
import usePutSelfPassword from 'entity/auth/usePutSelfPassword'
import ChangePasswordModal from '../FranchiseManagerDetail/ui/ChangePasswordModal'

const MyFranchise = () => {
	const navigate = useNavigate()
	const [userRole] = useRoleCookie()
	const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false)

	const [myFranchiseData, isLoading, refetchFranchise] = useGetMyFranchise()
	const [approveManager] = usePutStoreManagerApprove(refetchFranchise)
	const [unapproveManager] = useDeleteStoreManagerApprove(refetchFranchise)
	const isFranchiseOwner = myFranchiseData?.data?.franchise_manager?.is_mine
	const [changePasswordRequest, isPasswordChanging] =
		usePutSelfPassword(refetchFranchise)

	const btnList = []
	if (userRole === ROLE_FRANCHISE_MANAGER) {
		btnList.push({
			label: '프랜차이즈 정보 수정',
			clickEvent: () => navigate('/manager/my/edit'),
			deactive: false,
		})
		btnList.push({
			label: '비밀번호 변경',
			clickEvent: () => setIsPasswordModalOpen(true),
			deactive: false,
		})
	}
	const myDataList = [
		{
			label: 'IDX',
			value: myFranchiseData?.data?.franchise_manager?.idx,
		},
		{
			label: '승인 상태',
			value: myFranchiseData?.data?.franchise_manager?.is_approve
				? '승인'
				: '미승인',
		},
		{
			label: '관리자 이름',
			value: myFranchiseData?.data?.franchise_manager?.name,
		},
		{
			label: '관리자 연락처',
			value: myFranchiseData?.data?.franchise_manager?.contact,
		},
		{
			label: '가입 날짜',
			value: timestampCalculator(
				myFranchiseData?.data?.franchise_manager?.created_at
			),
		},
	]
	const myFranchiseDataList = [
		{
			label: 'IDX',
			value: myFranchiseData?.data?.franchise_manager?.franchise_idx,
		},
		{
			label: '대표 주소',
			value: myFranchiseData?.data?.franchise_manager?.franchise_address,
		},
		{
			label: '이름',
			value: myFranchiseData?.data?.franchise_manager?.franchise_name,
		},
		{
			label: '대표 연락처 정보',
			value: myFranchiseData?.data?.franchise_manager?.franchise_contact,
		},
		{
			label: '매장 매장 이용권',
			value: myFranchiseData?.data?.franchise_manager?.store_ticket_name,
		},
	]
	const logoImg = myFranchiseData?.data?.franchise_manager?.franchise_logo_img

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList}>프랜차이즈 정보 관리</MainHeader>

			<Style.AreaDiv>
				<h2>프랜차이즈 관리자 정보</h2>
				<DTStyle.TableDiv>
					{myDataList?.map((elem, index) => (
						<DTStyle.TableElement key={index}>
							<h2>{elem?.label}</h2>
							<p>{elem?.value}</p>
						</DTStyle.TableElement>
					))}
				</DTStyle.TableDiv>
			</Style.AreaDiv>

			<Style.AreaDiv>
				<h2>프랜차이즈 정보</h2>
				<DTStyle.TableDiv>
					{myFranchiseDataList?.map((elem, index) => (
						<DTStyle.TableElement key={index}>
							<h2>{elem?.label}</h2>
							<p>{elem?.value}</p>
						</DTStyle.TableElement>
					))}
				</DTStyle.TableDiv>
			</Style.AreaDiv>

			<Style.AreaDiv>
				<h2>프랜차이즈 로고 이미지</h2>
				{logoImg && (
					<div>
						<Style.LogoImg src={logoImg} />
					</div>
				)}
			</Style.AreaDiv>

			{isPasswordModalOpen && (
				<ChangePasswordModal
					isOpen={isPasswordModalOpen}
					onClose={() => setIsPasswordModalOpen(false)}
					onSubmit={(newPassword) => changePasswordRequest(newPassword)}
					isLoading={isPasswordChanging}
				/>
			)}
		</Style.Wrapper>
	)
}

export default MyFranchise
